import { Transaction, Account, Currency } from '../types';


// Default accounts that will be used if no accounts exist in localStorage
export const defaultAccounts: Account[] = [
  {
    id: 'acc-1',
    name: 'Main Checking',
    type: 'checking',
    balance: 12450.75,
    runningTotal: 12450.75,
    transactionCount: 0,
    currency: 'USD',
    institution: 'Bank of America',
    isActive: true,
    lastUpdated: new Date('2025-05-10T14:30:00'),
  },
  {
    id: 'acc-2',
    name: 'Business Savings',
    type: 'savings',
    balance: 58920.42,
    runningTotal: 58920.42,
    transactionCount: 0,
    currency: 'USD',
    institution: 'Chase',
    isActive: true,
    lastUpdated: new Date('2025-05-11T09:15:00'),
  },
  {
    id: 'acc-3',
    name: 'Investment Account',
    type: 'investment',
    balance: 125000.00,
    runningTotal: 125000.00,
    transactionCount: 0,
    currency: 'GBP',
    institution: 'Vanguard',
    isActive: true,
    lastUpdated: new Date('2025-05-09T16:45:00'),
  },
  {
    id: 'acc-4',
    name: 'Euro Business Account',
    type: 'checking',
    balance: 15000.00,
    runningTotal: 15000.00,
    transactionCount: 0,
    currency: 'USD',
    institution: 'Deutsche Bank',
    isActive: true,
    lastUpdated: new Date('2025-05-10T11:20:00'),
  },
];


// Generate dates for the last 30 days
const generateDates = (days: number) => {
  const dates: Date[] = [];
  const today = new Date();
  
  for (let i = days; i >= 0; i--) {
    const date = new Date();
    date.setDate(today.getDate() - i);
    dates.push(date);
  }
  
  return dates;
};

const last30Days = generateDates(30);

// ---------------------------------------------------------------------------
// Sample transactions – these help exercise inter-account transfer rules.
// Two example transfer pairs (Main Checking → Investment, Main Checking → Business Savings)
// Regex examples:
//    Side A pattern:  ^Transfer to .*
//    Side B pattern:  ^Transfer from .*
// ---------------------------------------------------------------------------
const sampleTransactions: Transaction[] = [
  {
    id: 'tx-1',
    userTransactionId: 'SAMPLE-TXN-001',
    timestamp: new Date('2025-05-02'),
    description: 'Transfer to Investment Account',
    amount: -5000,
    type: 'expense',
    category: 'Transfer',
    currency: 'USD',
    account: defaultAccounts[0], // Main Checking
    accountId: defaultAccounts[0].id,
    accountName: defaultAccounts[0].name,
    glAccountNumber: 'TRANSFER',
    glAccountName: 'Transfer Account',
    reconciled: false,
  },
  {
    id: 'tx-2',
    userTransactionId: 'SAMPLE-TXN-002',
    timestamp: new Date('2025-05-02'),
    description: 'Transfer from Main Checking',
    amount: 5000,
    type: 'income',
    category: 'Transfer',
    currency: 'USD',
    account: defaultAccounts[2], // Investment Account
    accountId: defaultAccounts[2].id,
    accountName: defaultAccounts[2].name,
    glAccountNumber: 'TRANSFER',
    glAccountName: 'Transfer Account',
    reconciled: false,
  },
  {
    id: 'tx-3',
    userTransactionId: 'SAMPLE-TXN-003',
    timestamp: new Date('2025-05-15'),
    description: 'Transfer to Business Savings',
    amount: -2500,
    type: 'expense',
    category: 'Transfer',
    currency: 'USD',
    account: defaultAccounts[0], // Main Checking
    accountId: defaultAccounts[0].id,
    accountName: defaultAccounts[0].name,
    glAccountNumber: 'TRANSFER',
    glAccountName: 'Transfer Account',
    reconciled: false,
  },
  {
    id: 'tx-4',
    userTransactionId: 'SAMPLE-TXN-004',
    timestamp: new Date('2025-05-15'),
    description: 'Transfer from Main Checking',
    amount: 2500,
    type: 'income',
    category: 'Transfer',
    currency: 'USD',
    account: defaultAccounts[1], // Business Savings
    accountId: defaultAccounts[1].id,
    accountName: defaultAccounts[1].name,
    glAccountNumber: 'TRANSFER',
    glAccountName: 'Transfer Account',
    reconciled: false,
  },
];


// Generate monthly income/expense data
export const monthlyFinancialData = {
  labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  income: [12500, 14200, 13800, 15000, 16200, 15500, 17000, 16800, 18000, 17500, 19000, 18500],
  expenses: [8500, 9200, 8900, 9500, 10200, 9800, 10500, 10300, 11000, 10800, 11500, 11200],
};

// Generate daily income/expense data for the last 30 days
export const dailyFinancialData = {
  labels: last30Days.map(date => date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })),
  income: last30Days.map(() => Math.floor(Math.random() * 500) + 300),
  expenses: last30Days.map(() => Math.floor(Math.random() * 300) + 100),
};


// Reconciliation status
export const reconciliationStatus = {
  total: sampleTransactions.length,
  reconciled: sampleTransactions.filter(t => t.reconciled).length,
  unreconciled: sampleTransactions.filter(t => !t.reconciled).length,
  lastReconciled: new Date('2025-05-10T14:30:00'),
};
